var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardLogo32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 92,
    height: 92,
    rx: 46,
    fill: "#EAFFEE",
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5526 62.3063L40.1409 47.7687L32.034 62.3063H26.0605L40.1409 37.6504L54.3737 62.3063H48.5526Z",
    fill: "#4FDD6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3297 37.6504L59.7718 52.1574L67.8482 37.6504H73.8217L59.7718 62.3063L45.5391 37.6504H51.3297Z",
    fill: "#4FDD6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLogo32);
export default __webpack_public_path__ + "static/media/card-logo-32.d0f40458ee6f3cc2e9f014e1e857f12b.svg";
export { ForwardRef as ReactComponent };